/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { ColorType, createChart, CrosshairMode, LineStyle } from 'lightweight-charts';
import ClipLoader from 'react-spinners/ClipLoader';
import { useSearchParams, useNavigate } from 'react-router-dom';
import moment from 'moment';
import candle from '../assets/images/candle.svg';
import ImageNotFound from '../assets/images/dataNotFound.png';

const GREEN = '#4A9C52';
const RED = '#ff311c';

const brandColor = '#9B7DFF';
// const socket = new WebSocket('wss://dev.e-mint.in/socket/ws');
const selectType = [
  {
    show: '1D',
    resolution: 1,
    startTime: () => {
      const date = new Date();
      // const weekDay = date.toLocaleDateString('en-US', { weekday: 'long' });
      // let minusDays = 1;
      // if (weekDay === 'Saturday') {
      //   minusDays = 1;
      // }
      // if (weekDay === 'Sunday') {
      //   minusDays = 2;
      // }
      // if (weekDay === 'Monday') {
      //   minusDays = 3;
      // }
      // date.setDate(date.getDate() - minusDays);
      date.setDate(date.getDate());
      date.setHours(9, 14);
      return Math.floor(date.getTime());
    },
    endTime: () => {
      const date = new Date();
      // const weekDay = date.toLocaleDateString('en-US', { weekday: 'long' });
      // const minusDays = 0;
      // if (weekDay === 'Saturday') {
      //   minusDays = 1;
      // }
      // if (weekDay === 'Sunday') {
      //   minusDays = 2;
      // }
      // if (weekDay === 'Monday') {
      //   minusDays = 3;
      // }
      date.setDate(date.getDate());
      date.setHours(15, 30);
      return Math.floor(date.getTime());
    },
  },
  {
    show: '1W',
    resolution: 5,
    startTime: () => {
      const date = new Date();
      date.setDate(date.getDate() - 7);
      date.setHours(9, 14);
      return Math.floor(date.getTime());
    },
    endTime: () => {
      const date = new Date();
      date.setDate(date.getDate());
      date.setHours(15, 30);
      return Math.floor(date.getTime());
    },
  },
  {
    show: '1M',
    resolution: 15,
    startTime: () => {
      const date = new Date();
      date.setMonth(date.getMonth() - 1);
      date.setHours(9, 14);
      return Math.floor(date.getTime());
    },
    endTime: () => {
      const date = new Date();
      date.setDate(date.getDate());
      date.setHours(15, 30);
      return Math.floor(date.getTime());
    },
  },
  {
    show: '1Y',
    resolution: 'D',
    startTime: () => {
      const date = new Date();
      date.setFullYear(date.getFullYear() - 1);
      date.setHours(9, 14);
      return Math.floor(date.getTime());
    },
    endTime: () => {
      const date = new Date();
      date.setDate(date.getDate());
      date.setHours(15, 30);
      return Math.floor(date.getTime());
    },
  },
  {
    show: '5Y',
    resolution: 'W',
    startTime: () => {
      const date = new Date();
      date.setFullYear(date.getFullYear() - 5);
      date.setHours(9, 14);
      return Math.floor(date.getTime());
    },
    endTime: () => {
      const date = new Date();
      date.setDate(date.getDate() - 1);
      date.setHours(15, 30);
      return Math.floor(date.getTime());
    },
  },
];

function Loader({ chartLoading }) {
  const [searchParams] = useSearchParams();
  return (
    <div style={{ height: `${searchParams.get('height')}px` }} className="loader-flex">
      <ClipLoader
        color="#2B615C"
        loading={chartLoading}
        cssOverride={{
          display: 'block',
          margin: '0 auto',
          borderColor: GREEN,
        }}
        size={50}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>
  );
}

function ChartComponent({
  selectedChart,
  // symbol,
  name,
  timeData,
  colors: { backgroundColor = 'white', textColor = '#949494' },
}) {
  const chartContainerRef = useRef();
  const [searchParams] = useSearchParams();
  // const [isSubscribed, setIsSubscribed] = useState(false);
  // const [todayDate, setTodayDate] = useState(new Date());
  const [toolTipData, setToolTipData] = useState({
    top: '0px',
    left: '0px',
    display: 'none',
    price: {},
    time: '',
    visible: false,
  });
  // useEffect(() => {
  //   // setTodayDate(new Date());
  //   console.log('isSubscribed');
  //   console.log(isSubscribed);
  //   if (!isSubscribed) {
  //     socket.send(JSON.stringify({ action: 'subscribe', value: [name] }));
  //     setIsSubscribed(true);
  //     console.log('Subscribed');
  //   } else {
  //     console.log('Not Subscribed');
  //   }
  // }, []);
  useEffect(() => {
    const op = {
      layout: {
        background: {
          type: ColorType.Solid,
          color: backgroundColor,
        },
        textColor,
      },
      grid: {
        horzLines: {
          color: '#ededed',
        },
        vertLines: {
          color: '#ededed',
        },
      },
      rightPriceScale: {
        borderVisible: false,
        entireTextOnly: false,
        autoScale: true,
        visible: true,
        // scaleMargins: {
        //   top: 0.3,
        //   bottom: 0.25,
        // },
      },

      timeScale: {
        borderVisible: false,
        visible: false,

        timeVisible: false,
        // Hide seconds on time axis
        // rightOffset: 12, // Adjust the right offset for better visibility
        // barSpacing: 6, // Adjust the spacing between bars
        // fixLeftEdge: true,
      },
      crosshair: {
        // Change mode from default 'magnet' to 'normal'.
        // Allows the crosshair to move freely without snapping to datapoints
        mode: CrosshairMode.Magnet,

        // Vertical crosshair line (showing Date in Label)
        vertLine: {
          width: 1,
          color: 'rgba(0,0,0,0.2)',
          style: LineStyle.Solid,
          labelBackgroundColor: brandColor,
        },

        // Horizontal crosshair line (showing Price in Label)
        horzLine: {
          width: 1,
          color: brandColor,
          labelBackgroundColor: brandColor,
        },
      },
      handleScroll: {
        mouseWheel: true,
        pressedMouseMove: true,
        horzTouchDrag: true,
        vertTouchDrag: true,
      },
      handleScale: {
        axisPressedMouseMove: true,
        mouseWheel: true,
        pinch: true,
      },
      localization: {
        // locale: 'en-IN',
        // dateFormat: "dd MMM 'yyyy",
        timeFormatter: (time) => {
          const date = new Date(time * 1000);
          return date.toLocaleString('en-IN', {
            // hour: 'numeric',
            // minute: 'numeric',
            timezone: 'Asia/Kolkata',
          });
        },
      },
      width: chartContainerRef.current?.clientWidth,
      height: parseFloat(searchParams.get('height')) || 400,
    };
    document.body.style.position = 'relative';

    const container = document.createElement('div');
    document.body.appendChild(container);
    const chart = createChart(chartContainerRef.current, op);
    const widthButton = 27;
    const heightButtton = 27;
    const width = chartContainerRef.current?.clientWidth;
    const height = parseFloat(searchParams.get('height')) || 400;

    const button = document.createElement('div');
    button.className = 'go-to-realtime-button';
    button.style.left = `${width - widthButton - 60}px`;
    button.style.top = `${height - heightButtton - 30}px`;
    button.style.color = '#4c525e';
    button.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" width="14" height="14"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M6.5 1.5l5 5.5-5 5.5M3 4l2.5 3L3 10"></path></svg>';
    document.body.appendChild(button);

    const timeScale = chart.timeScale();
    timeScale.subscribeVisibleTimeRangeChange(() => {
      const buttonVisible = timeScale.scrollPosition() < 0;
      button.style.display = buttonVisible ? 'block' : 'none';
    });

    button.addEventListener('click', () => {
      timeScale.scrollToRealTime();
    });

    button.addEventListener('mouseover', () => {
      button.style.background = 'rgba(250, 250, 250, 1)';
      button.style.color = '#000';
    });

    button.addEventListener('mouseout', () => {
      button.style.background = 'rgba(250, 250, 250, 0.6)';
      button.style.color = '#4c525e';
    });

    const newSeries = chart.addAreaSeries({
      topColor: timeData[0].value < timeData[timeData.length - 1].value ? GREEN : RED,
      bottomColor: 'whitesmoke', // 'transparent',
      lineColor: timeData[0].value < timeData[timeData.length - 1].value ? GREEN : RED,
      lineWidth: 2,
    });

    newSeries.setData(timeData);

    chart.timeScale().fitContent();

    chart.timeScale().setVisibleRange({
      from: timeData[0].time,
      to: timeData[timeData.length - 1].time,
    });
    const toolTipWidth = 80;
    const toolTipHeight = 80;
    const toolTipMargin = 15;

    chart.subscribeCrosshairMove((param) => {
      // console.log(param);
      if (
        !!param.point === false ||
        !param.time ||
        param.point.x < 0 ||
        param.point.x > chartContainerRef.current.clientWidth ||
        param.point.y < 0 ||
        param.point.y > chartContainerRef.current.clientHeight
      ) {
        setToolTipData({ ...toolTipData, visible: false });
      } else {
        const price = param.seriesData.get(newSeries);
        const coordinate = newSeries.priceToCoordinate(price.open);
        let shiftedCoordinate = param.point.x - 50;
        if (coordinate === null) {
          return;
        }
        shiftedCoordinate = Math.max(
          0,
          Math.min(chartContainerRef.current.clientWidth - toolTipWidth, shiftedCoordinate)
        );

        const coordinateY =
          coordinate - toolTipHeight - toolTipMargin > 0
            ? coordinate - toolTipHeight - toolTipMargin
            : Math.max(
                0,
                Math.min(
                  chartContainerRef.current.clientHeight - toolTipHeight - toolTipMargin,
                  coordinate + toolTipMargin
                )
              );

        setToolTipData({
          ...toolTipData,
          visible: true,
          left: `${shiftedCoordinate + 50}px`,
          top: `${coordinateY + 10}px`,
          price,
          time: param.time * 1000,
        });
      }
    });

    const handleResize = () => {
      chart.applyOptions({ width: chartContainerRef.current.clientWidth });
      chart.timeScale().setVisibleRange({
        from: timeData[0].time,
        to: timeData[timeData.length - 1].time,
      });
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      chart.remove();
    };
  }, [timeData]);

  return (
    <div className="chartComponentWrapper" style={{ height: `${searchParams.get('height')}px` }}>
      <div ref={chartContainerRef} className="doning">
        {toolTipData.visible && (
          <div className="floating-tooltip-2" style={{ top: toolTipData.top, left: toolTipData.left }}>
            <div style={{ color: '#2B615C', fontWeight: 600, textTransform: 'capitalize' }}>{name.toUpperCase()}</div>
            <div style={{ fontSize: '14px', margin: '4px 0px', color: '#21384d' }}>{toolTipData.price.value}</div>
            <p style={{ color: '#21384d', fontWeight: '500', fontSize: '12px', textAlign: 'center' }}>
              {selectedChart.show === '1D' && moment(toolTipData.time).format('DD-MMM-YYYY hh:mm:ss a')}
              {selectedChart.show === '1W' && moment(toolTipData.time).format('DD-MM-YYYY HH:mm')}
              {selectedChart.show === '1M' && moment(toolTipData.time).format('DD-MM-YYYY HH:mm')}
              {selectedChart.show === '1Y' && moment(toolTipData.time).format('DD-MM-YYYY')}
              {selectedChart.show === '5Y' && moment(toolTipData.time).format('DD-MM-YYYY')}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

function Chart() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [timeData, setTimeData] = useState([]);
  const selected = selectType.find((each) => each.show === (searchParams.get('selectType') || '1D'));
  const [dataObj, setDataObj] = useState({ ...selected, startTime: selected.startTime(), endTime: selected.endTime() });
  const [chartLoading, setChartLoading] = useState(false);
  const [retryCount, setRetryCount] = useState(-1);

  const [allDataObj, setAllDataObj] = useState([]);

  const [noData, setNoData] = useState(false);
  const handleChangeChart = () => {
    navigate(
      `/candle_charts?symbol=${searchParams.get('symbol')}&name=${searchParams.get('name')}&height=${searchParams.get(
        'height'
      )}`
    );
  };

  useEffect(() => {
    const found = selectType.find((each) => each.show === dataObj.show);
    if (found) {
      setTimeData(dataObj);
    }
  }, [dataObj]);

  useEffect(() => {
    if (allDataObj[0]) {
      const found = allDataObj.find((each) => each.show === dataObj.show);
      if (found) {
        setTimeData(found.data);
      }
    }
  }, [allDataObj]);

  const fetchData = async ({ resolution, startTime, endTime }) => {
    try {
      let dataX = JSON.stringify({
        startTime,
        endTime, // endTimeX,
        bucket: 1,
        instrument: searchParams.get('symbol'),
      });
      let timeRequest = 'min';
      if (resolution === 1) {
        // day
        timeRequest = 'min';
      } else if (resolution === 5) {
        // 1week
        dataX = JSON.stringify({
          startTime,
          endTime, // endTimeX,
          bucket: 15,
          instrument: searchParams.get('symbol'),
        });
        timeRequest = 'min';
      } else if (resolution === 15) {
        dataX = JSON.stringify({
          startTime,
          endTime, // endTimeX,
          bucket: 1,
          instrument: searchParams.get('symbol'),
        });
        // month
        timeRequest = 'hour';
      } else if (resolution === 'D') {
        // 1y
        timeRequest = 'day';
      } else if (resolution === 'W') {
        // 5y
        dataX = JSON.stringify({
          startTime,
          endTime, // endTimeX,
          bucket: 1,
          instrument: searchParams.get('symbol'),
        });
        timeRequest = 'week';
      } else {
        timeRequest = 'min';
      }
      console.log(process.env.REACT_APP_BASE_API_URL);
      const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_BASE_API_URL}/chart/charting/${timeRequest}`,
        headers: {
          'Content-Type': 'application/json',
        },
        data: dataX,
      };
      // const response = await axios(config);
      // const objData = response.data.data.chartingData.map((each) => ({
      //   time: each[0],
      //   value: each[4],
      // }));
      const response = await axios(config);
      const uniqueTimes = new Set();
      const objData = response.data.data.chartingData.reduce((result, each) => {
        const time = each[0];
        if (!uniqueTimes.has(time)) {
          uniqueTimes.add(time);
          result.push({
            time: each[0] / 1000,
            value: each[4],
          });
        }
        return result;
      }, []);
      return objData;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  useEffect(() => {
    if (!!searchParams.get('symbol') === false) {
      alert('Invalid Symbol');
      setNoData(true);
    }
    if (!!searchParams.get('selectType') === false) {
      // alert('please send a defulat selection option');
    }
  }, []);
  const retryApiFetch = (requestData) => {
    console.log('retryCount 1', retryCount);
    setRetryCount(retryCount + 1);
    console.log('retryCount 2', retryCount);
    const newReqData = {
      resolution: requestData.resolution,
      startTime: typeof requestData.startTime === 'number' ? requestData.startTime - 86400 * 1000 : dataObj.startTime(),
      endTime: typeof requestData.endTime === 'number' ? requestData.endTime - 86400 * 1000 : dataObj.endTime(),
      show: dataObj.show,
    };
    if (retryCount < 10 || retryCount !== -1) {
      fetchData(newReqData)
        .then((response) => {
          // console.log(response);
          if (!response?.[0]) {
            retryApiFetch(newReqData);
          } else {
            setRetryCount(-1);
            setChartLoading(false);
            setAllDataObj([...allDataObj, { show: dataObj.show, data: response }]);
          }
        })
        .catch(() => {
          setNoData(true);
        });
    } else {
      setNoData(true);
    }
  };

  useEffect(() => {
    if (dataObj) {
      const exist = allDataObj.find((each) => each.show === dataObj.show);
      if (exist) {
        setTimeData(exist.data);
      } else {
        setChartLoading(true);
        fetchData({
          resolution: dataObj.resolution,
          startTime: typeof dataObj.startTime === 'number' ? dataObj.startTime : dataObj.startTime(),
          endTime: typeof dataObj.endTime === 'number' ? dataObj.endTime : dataObj.endTime(),
          show: dataObj.show,
        })
          .then((response) => {
            // console.log(response);
            if (!response?.[0]) {
              retryApiFetch(dataObj);
            } else {
              setRetryCount(-1);
              setChartLoading(false);
              setAllDataObj([...allDataObj, { show: dataObj.show, data: response }]);
            }
          })
          .catch(() => {
            setNoData(true);
          });
      }
    }
  }, [dataObj]);

  return (
    <div style={{ width: '100%', height: `${searchParams.get('height')}px` }}>
      {noData ? (
        <div className="noDataImg">
          <img src={ImageNotFound} alt="No data" />
        </div>
      ) : (
        <>
          {timeData?.[0]?.time && (
            <>
              {!chartLoading ? (
                <ChartComponent
                  selectedChart={dataObj}
                  symbol={searchParams.get('symbol')}
                  name={searchParams.get('name')}
                  timeData={timeData}
                  colors={{
                    backgroundColor: '#FFFFFF',
                    lineColor: '#b0fc38',
                    textColor: 'black',
                    areaTopColor: '#b0fc38',
                    areaBottomColor: 'whitesmoke',
                  }}
                />
              ) : (
                <Loader chartLoading={chartLoading} />
              )}

              <div className="select-wrapper">
                {selectType.map((each) => (
                  <h4
                    key={`${Math.random()}-jdidi`}
                    style={{
                      backgroundColor: each.show === dataObj.show ? '#2B625D' : 'transparent',
                      color: each.show === dataObj.show ? 'whitesmoke' : 'inherit',
                    }}
                    className="select-bar"
                    onClick={() => {
                      setDataObj({
                        resolution: each.resolution,
                        startTime: each.startTime(),
                        endTime: each.endTime(),
                        show: each.show,
                      });
                    }}
                    aria-hidden="true"
                  >
                    {each.show}
                  </h4>
                ))}
                <h4 onClick={handleChangeChart} className="select-bar" aria-hidden="true">
                  <img className="chart-icon" src={candle} alt="" />
                </h4>
              </div>
            </>
          )}
          {!timeData?.[0]?.time && <Loader chartLoading={chartLoading} />}
        </>
      )}
    </div>
  );
}

function ChartModule() {
  return (
    <div className="chart-module_wrapper">
      <Chart />
    </div>
  );
}
export default ChartModule;
